/** Copy for the TRAUMA_CONTACT confirm + success popups. */

export const TRAUMA_CONTACT_MODAL_TITLE = 'Contact TRiM team';

export const TRAUMA_CONTACT_MODAL_INTRO =
  "If you'd like to connect directly with the TRiM team, you can reach out to them directly here.";

export const TRAUMA_CONTACT_IDENTITY_HEADING = 'Your identity will be shared';

export const TRAUMA_CONTACT_IDENTITY_BODY =
  'Contacting a TRiM practitioner requires sharing your details so they can reach you directly. The following will be sent to the practitioner team:';

export const TRAUMA_CONTACT_FULL_NAME_LABEL = 'Full name:';

export const TRAUMA_CONTACT_EMAIL_LABEL = 'Email:';

export const TRAUMA_CONTACT_CONSENT_LABEL =
  'I understand that my name and email address will be shared with the TRiM practitioner team so they can contact me directly.';

export const TRAUMA_CONTACT_CANCEL_LABEL = 'Cancel';

export const TRAUMA_CONTACT_CONFIRM_LABEL = 'Send my details';

export const TRAUMA_CONTACT_SUCCESS_TITLE = 'Your details have been sent';

export const TRAUMA_CONTACT_SUCCESS_DESCRIPTION_PREFIX =
  'The TRiM team will be in touch with you at';

export const TRAUMA_CONTACT_SUCCESS_DESCRIPTION_SUFFIX = 'to arrange a convenient time.';

export const TRAUMA_CONTACT_DONE_LABEL = 'Done';

export const TRAUMA_CONTACT_ERROR_MESSAGE = 'We could not send your request. Please try again.';
